import { COUNTRIES, translateCountry, type CountryIso, type LocaleIso } from 'utils';
import { COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION, COUNTRIES_WITHOUT_CART } from '../../../constants';

export interface CountryOption {
  id: string;
  text: string;
}

function getAvailableCountries(currentCountry: CountryIso) {
  // Global-address locales can select from every supported country; other locales exclude global-only countries.
  const allowsGlobalAddressSelection = COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION.includes(
    currentCountry as (typeof COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION)[number]
  );

  if (allowsGlobalAddressSelection) {
    return COUNTRIES;
  }

  return COUNTRIES.filter(
    country =>
      !COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION.includes(
        country.code as (typeof COUNTRIES_WITH_GLOBAL_ADDRESS_SELECTION)[number]
      )
  );
}

export function getCountryData(locale: LocaleIso, currentCountry: CountryIso): CountryOption[] {
  // Keep the form options aligned with cart availability and use localized names for the sorted display list.
  return getAvailableCountries(currentCountry)
    .filter(country => !COUNTRIES_WITHOUT_CART.includes(country.code as (typeof COUNTRIES_WITHOUT_CART)[number]))
    .filter(country => country.code !== 'EN')
    .map(country => ({
      id: country.code.toLowerCase(),
      text: translateCountry(locale, country.code)
    }))
    .sort((firstCountry, secondCountry) => firstCountry.text.localeCompare(secondCountry.text, locale));
}